import { Component, OnInit, ViewChild } from '@angular/core';
import { DetailStoreService } from 'src/app/itineries/services/store/detail-store/detail-store.service';
import { DriversStoreService } from 'src/app/itineries/services/store/drivers-store/drivers-store.service';
import { FiltersStoreService } from 'src/app/itineries/services/store/filters-store/filters-store.service';
import { FleetStoreService } from 'src/app/itineries/services/store/fleet-store/fleet-store.service';
import { FundingsourcestoreService } from 'src/app/itineries/services/store/fundingsource-store/fundingsource-store.service';
import { LosStoreService } from 'src/app/itineries/services/store/los-store/los-store.service';
import { SearchStoreService } from 'src/app/itineries/services/store/search-store/search-store.service';
import { ServiceareaStoreService } from 'src/app/itineries/services/store/servicearea-store/servicearea-store.service';
import { SpaceTypeStoreService } from 'src/app/itineries/services/store/spacetype-store/spacetype-store.service';
import { TripStoreService } from 'src/app/itineries/services/store/trip-store/trip-store.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import * as _ from 'underscore';
import { AgmMap } from '@agm/core';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { WaypointsStoreService } from 'src/app/itineries/services/store/waypoint-store/waypoints-store.service';
import { TranslationService } from 'src/app/service/translation-service/translation.service';

@Component({
  selector: 'app-itineries',
  templateUrl: './itineries.component.html',
  styleUrls: ['./itineries.component.css']
})
export class ItineriesComponent implements OnInit {
  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
   latitude = 35.125801;
   longitude = -117.9859038;
   initialZoom = 12;
   selectedTab = 'Timeline'
   user: any;
   trips: any = [];
   filterTripsList = [];
   spaceTypeList = [];
   levelOfServiceList = [];
   preLevelOfServices: any = {};
   preSpaceTypes: any = {};
   skip = 0;
   currentDate;
   agmMap;
   selectedSpaceType;
   selectedStatus = [];
   timeZone;
   mapTrips = [];
   wayPoints;
  renderOptions = {
    suppressMarkers: true,

  };
  isResizing = false;

   constructor(
     private sharedDataService: SharedDataService,
     private driverService: DriversService,
     private fleetService: FleetService,
     private serviceArea: ServiceAreasService,
     private corporateService: CorporateService,
     private los: LevelOfServiceService,
     private fundingSourceStore: FundingsourcestoreService,
     private spaceTypeStore: SpaceTypeStoreService,
     private serviceAreasStore: ServiceareaStoreService,
     private losStore: LosStoreService,
     private driverStore: DriversStoreService,
     private fleetStore: FleetStoreService,
     private assignTripService: AssigTripsService,
     private filtersStoreService: FiltersStoreService,
     private tripStore: TripStoreService,
     private detailStore: DetailStoreService,
     private searchStore: SearchStoreService,
     private waypointStore: WaypointsStoreService,
     private translationService: TranslationService
   ) { }

   ngOnInit() {
     this.translationService.locale$
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe(() => this.refreshStatusLabels());
   }

   ngAfterViewInit() {
     this.agmElement.mapReady
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe((map) => {
         this.agmMap = map;
         this.getUser();
       });
   }

   onSearch(data) {
     if (data) {
       this.currentDate = data.date;
       this.skip = 0;
       this.trips = [];
       this.filterTripsList = [];
       this.tripStore.setEntities([]);
       this.filtersStoreService.setEntities([], []);
       this.detailStore.setEntities([]);

       const payload: any = {
         isShowAllTrips: false,
         status: 'all',
         showBreak: true,
         skip: this.skip,
         scheduleTime: data.date.toString(),
       };

       if (data.cooperates && data.cooperates.length) {
         payload.cooperates = data.cooperates.toString();
       }
       if (data.serviceAreas && data.serviceAreas.length) {
         payload.serviceAreas = data.serviceAreas.toString();
       }
       if (data.spaceTypes && data.spaceTypes.length) {
         payload.spaceTypes = data.spaceTypes.toString();
       }
       if (data.reference) {
         payload.tripId = data.reference;
       }

       this.getTrips(payload);
     }

   }


   getTrips(payload?: any) {
     this.assignTripService.getTripListNew(payload).pipe(takeUntil(componentDestroyed(this)))
       .subscribe(
         (data) => {
           this.trips = [...data, ...this.trips];
           if (data.length) {
             this.skip += data.length;
             this.getTrips({ ...payload, skip: this.skip });

           } else {
             this.prepareData();
           }

         }, err => {
           sweetAlert('Error', err, 'warning', 'OK');
         });
   }

   prepareData() {
     this.filterTripsList = this.trips;
     this.tripStore.setEntities(this.filterTripsList);
     let services = [];

     const statuses = this.buildStatuses();

     for (let item of this.trips) {
       if (this.preLevelOfServices && this.preLevelOfServices[item.los]) {
         services.push({ ...this.preLevelOfServices[item.los], selected: true });
       }
     }
     services = _.uniq(services, '_id').sort();

     this.filtersStoreService.setEntities(services, statuses)
     this.filterTrips();
   }

   private buildStatuses(existing?: any[]) {
     const defs = [
       { nameKey: 'willCall', value: ['willcall'] },
       { nameKey: 'pending', value: ['marketplaced', 'pending', 'offered', 'accepted'] },
       { nameKey: 'onway', value: ['onway'] },
       { nameKey: 'arrived', value: ['arrived'] },
       { nameKey: 'inVehicle', value: ['started'] },
       { nameKey: 'exiting', value: ['completed'] },
       { nameKey: 'canceled', value: ['cancelled'] },
       { nameKey: 'rode', value: ['finished'] },
     ];
     return defs.map(d => {
       const prev = (existing || []).find(e =>
         e.nameKey === d.nameKey ||
         (Array.isArray(e.value) && e.value.join(',') === d.value.join(','))
       );
       return {
         nameKey: d.nameKey,
         name: this.translationService.getTranslation(d.nameKey) || d.nameKey,
         value: d.value,
         selected: prev ? !!prev.selected : true
       };
     });
   }

   private refreshStatusLabels() {
     const current = this.filtersStoreService.currentState;
     if (!current || !current.statuses || !current.statuses.length) {
       return;
     }
     this.filtersStoreService.setStatus(this.buildStatuses(current.statuses));
   }

   getUser() {
     this.sharedDataService
       .getUser()
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe(user => {
         if (user) {
           this.user = user
           this.timeZone = user.company ? user.company.timeZone : user.timeZone;
           this.latitude = user.latitude;
           this.longitude = user.longitude;
           this.skip = 0;
           this.trips = [];
           this.filterTripsList = [];
           this.tripStore.setEntities([]);
           this.wayPoints = [];
           this.filtersStoreService.setEntities([], []);
           this.makeCompulsoryCalls();
         }
       });
   }

   makeCompulsoryCalls() {


         this.spaceTypeStore.state$.subscribe((res) => {
       if (res) {
         this.spaceTypeList = res.list
         this.preSpaceTypes = res.map;
       }
     })

     this.losStore.state$.subscribe((res) => {
       if (res) {
         this.levelOfServiceList = res.list;
         this.preLevelOfServices = res.map;
       }
     })

     this.detailStore.state$.subscribe((data: any) => {
       this.mapTrips = data.list;
       this.setBounds(this.mapTrips);

     })
     this.waypointStore.state$.subscribe((data: any) => {
       this.wayPoints = data.list
     })

     this.filtersStoreService.state$.subscribe((res) => {
       if (res) {
         this.selectedStatus = res.statuses;
         this.selectedSpaceType = res.services;
         this.filterTrips();
       }
     })

     this.searchStore.state$.subscribe((res: any) => {
       if (res) {
         this.onSearch(res);
       }
     })

     const requests = [
       this.corporateService.getCorporateUsers('active'),
       this.los.getLevelOfServices({ status: 'active' }),
       this.los.getSpaceTypes({ status: 'active' }),
       this.serviceArea.getServiceAreas({ status: 'active' }),
       this.driverService.getDrivers(this.user._id, "active"),
       this.fleetService.getFleetList({ 'isFleetSection': true, 'status': 'active' })
     ];

     // Make all requests in parallel
     forkJoin(requests).subscribe(
       ([res1, res2, res3, res4, res5, res6]) => {
         if (res1) {
           this.fundingSourceStore.setEntities(res1);
         }
         if (res2) {
           this.losStore.setEntities(res2);
         }
         if (res3) {
           this.spaceTypeStore.setEntities(res3);
         }

         if (res4) {
           this.serviceAreasStore.setEntities(res4);
         }
         if (res5) {
           this.driverStore.setEntities(res5);
         }
         if (res6) {
           this.fleetStore.setEntities(res6);
         }
 ;
       },
       error => {
         sweetAlert('Error', error, 'error', 'OK');
       }
     );
   }

   filterTrips() {
     const selectedStatuses = this.selectedStatus
       .filter(status => status.selected)
       .reduce((acc, curr) => acc.concat(curr.value), []);

     const hasStatusFilter = selectedStatuses.length > 0;

     const willCallTime = moment().tz(this.timeZone).hour(22).minute(0).second(0).millisecond(0);

     this.filterTripsList = this.trips.filter(trip => {

       const matchesStatus =
         !hasStatusFilter ||
         (selectedStatuses.includes(trip.jobStatus));


         const selectedSpaceTypeIds = (this.selectedSpaceType || []).filter(status => status.selected).map(item => item._id);
         const hasSpaceTypeFilter = selectedSpaceTypeIds.length > 0;

       let matchesSpaceType =
         !hasSpaceTypeFilter || selectedSpaceTypeIds.includes(trip.los);

       if (matchesStatus && trip.isBreakTrip) matchesSpaceType = true;


       let isCompatible = (matchesStatus && matchesSpaceType);


       if (isCompatible && !selectedStatuses.includes('willcall')) {
          const orignalTime = moment(trip.scheduleTime).tz(this.timeZone);
         isCompatible = !moment(orignalTime.format('HH:mm:ss'), 'HH:mm:ss').tz(this.timeZone).isSameOrAfter(willCallTime);
       }

       return isCompatible;
     });


     this.tripStore.setEntities(this.filterTripsList);
     this.detailStore.setEntities([]);

   }


   setBounds(trips) {
     if (this.agmMap && trips && trips.length) {
       const bounds = new google.maps.LatLngBounds();
       for (const trip of trips) {
         bounds.extend(
           new window["google"].maps.LatLng(
             trip.jobOriginLatitude,
             trip.jobOriginLongitude
           )
         );
       }
       this.agmMap.fitBounds(bounds);
       this.agmMap.setCenter(bounds.getCenter());
     }
   }


   onUpdateTrip(trip: any) {
     const indexTwo = this.trips.findIndex((item) => item._id === trip._id);
     if (indexTwo !== -1) {
       this.trips[indexTwo] = trip;
     }
   }

   quickFilter(data) {
     this.currentDate = data.date;
     this.skip = 0;
     this.trips = [];
     this.filterTripsList = [];
     this.tripStore.setEntities([]);
     this.filtersStoreService.setEntities([], []);
     this.detailStore.setEntities([]);
     this.wayPoints = [];
     this.waypointStore.setEntities([]);

     const payload: any = {
       isShowAllTrips: false,
       status: 'all',
       skip: this.skip,
       ...data

     };
     this.getTrips(payload);

   }

   changeTab(tab: string) {
     this.selectedTab = tab;
     if (this.selectedTab === 'Table'){
      this.detailStore.setEntities([]);
       this.wayPoints = [];
       this.waypointStore.setEntities([]);
     }
   }


  getMarkeBall(assign, isPickup) {

    let icon = isPickup ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    if (assign.jobStatus === 'finished' || assign.jobStatus === 'cancelled') {
      icon = 'assets/images/map/finished_circle.png';
    }

    return icon;
  }


  horizontalResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarLeft = document.getElementById('horizontal-sidebar-left');
    const sidebarRight = document.getElementById('horizontal-sidebar-right');

    if (sidebarLeft && sidebarRight) {
      const initialWidthL = sidebarLeft.offsetWidth;
      const initialWidthR = sidebarRight.offsetWidth;
      const startX = event.clientX;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientX - startX;
          const newWidthL = initialWidthL + offsetX;
          const newWidthR = initialWidthR - offsetX;

          if (newWidthL >= 0 && newWidthR >= 0) {
            sidebarLeft.style.width = newWidthL + 'px';
            sidebarRight.style.width = newWidthR + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }

  startResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarTop = document.getElementById('resizable-sidebar-top');
    const sidebarBottom = document.getElementById('resizable-sidebar-bottom');

    if (sidebarTop && sidebarBottom) {
      const initialHeightT = sidebarTop.offsetHeight;
      const initialHeightB = sidebarBottom.offsetHeight;
      const startX = event.clientY;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientY - startX;
          const newHeightT = initialHeightT + offsetX;
          const newHeightB = initialHeightB - offsetX;

          if (newHeightT >= 0 && newHeightB >= 0) {
            sidebarTop.style.height = newHeightT + 'px';
            sidebarBottom.style.height = newHeightB + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }



   ngOnDestroy(): void {

   }

   trackByFn(index: number, item: any): number {
     return index;
   }

  startHorizontalResizing(event: MouseEvent) {
    this.isResizing = true;

    const leftPane = document.getElementById('resizable-left-pane');
    const rightPane = document.getElementById('resizable-right-pane');

    if (!leftPane || !rightPane) return;

    const startX = event.clientX;
    const startLeftWidth = leftPane.offsetWidth;
    const containerWidth = leftPane.parentElement!.offsetWidth;

    const mouseMoveHandler = (e: MouseEvent) => {
      if (!this.isResizing) return;

      const offsetX = e.clientX - startX;
      let newLeftWidth = startLeftWidth + offsetX;

      // Constrain width to between 200px and 80% of container
      newLeftWidth = Math.max(200, Math.min(newLeftWidth, containerWidth * 0.8));

      leftPane.style.width = `${newLeftWidth}px`;
      rightPane.style.width = `${containerWidth - newLeftWidth}px`;
    };

    const mouseUpHandler = () => {
      this.isResizing = false;
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }


 }
